import ServiceExec from '@/common/utils/ServiceExec';

class ElectSvc extends ServiceExec {
    getElectUserList = function (params = {}) {
        return this.queryPost('/api/app/elect/getElectUserList', params)
        .then(res => res.data)
    }
}

export default new ElectSvc
